<section id="{{sectionUUID}}">

   <div id="{{containerUUID}}" class="logi-dashboard"></div>

</section>